export default {"src":"/_next/static/media/error-icon.7d66a821.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};